import {
  IIneligibleAccountDialogProps,
  IneligibleAccountDialog,
} from '../IneligibleAccountDialog';
import { ISuccessDialogProps, SuccessDialog } from '../SuccessDialog';
import { IWelcomeDialogProps, WelcomeDialog } from '../WelcomeDialog';
import {
  ISwitchAccountDialogProps,
  SwitchAccountDialog,
} from '../SwitchAccountDialog';

export interface IReferralFlowProps {
  ineligibleAccountDialogProps: IIneligibleAccountDialogProps;
  successDialogProps: ISuccessDialogProps;
  switchAccountDialogProps: ISwitchAccountDialogProps;
  welcomeDialogProps: IWelcomeDialogProps;
}

export const ReferralFlow = ({
  ineligibleAccountDialogProps,
  successDialogProps,
  switchAccountDialogProps,
  welcomeDialogProps,
}: IReferralFlowProps) => {
  return (
    <>
      <WelcomeDialog {...welcomeDialogProps} />
      <SuccessDialog {...successDialogProps} />
      <IneligibleAccountDialog {...ineligibleAccountDialogProps} />
      <SwitchAccountDialog {...switchAccountDialogProps} />
    </>
  );
};
